import compileFontPairConfig from './compile-font-pair-config';

let cachedConfig = null;
let cachedCompiledConfig = null;

const getCompiledFontPairConfig = (config) => {
  if (cachedConfig === config && cachedCompiledConfig) {
    return cachedCompiledConfig;
  }

  cachedConfig = config;
  cachedCompiledConfig = compileFontPairConfig(config);

  return cachedCompiledConfig;
};

export default getCompiledFontPairConfig;
